<template>
  <div id="join">
    <!-- <div class="hero-bg">
      <div class="hero">
        <div class="hero-title">
          与晓A精灵一起<br />
          <span class="blue">重新定义英语教育</span>
        </div>
        <div class="hero-desc">
          加入我们，共享AI英语教育红利。0.5秒全维学习诊断技术，200+教育科技专家方法<br />论，500+国际场景训练，助您轻松创业。
        </div>
      </div>
    </div> -->
    <div class="section-title-small">
      核心优势
    </div>
    <div class="section-title">AI驱动英语教学，打造英语教育智能新基建</div>
    <div class="ai-advantage">
      <div class="ai-card">
        <div class="icon icon1"></div>
        <div class="ai-card-title">AI驱动教学</div>
        <div class="ai-card-desc">0.5秒全维学习诊断，精准修正学习问题</div>
        <div class="ai-card-desc">智能动态难度调节，匹配学生能力水平</div>
      </div>
      <div class="ai-card">
        <div class="icon icon2"></div>
        <div class="ai-card-title">全球资源库</div>
        <div class="ai-card-desc">100万本地化题库，精准覆盖区域考点</div>
        <div class="ai-card-desc">500+真实国际场景，培养全球胜任力</div>
      </div>
      <div class="ai-card">
        <div class="icon icon3"></div>
        <div class="ai-card-title">智能运营支持</div>
        <div class="ai-card-desc">招生引流系统，有效提升到店体验转化率</div>
        <div class="ai-card-desc">教学管理平台，大幅降低门店运营成本</div>
      </div>
      <div class="ai-card">
        <div class="icon icon4"></div>
        <div class="ai-card-title">效果有保障</div>
        <div class="ai-card-desc">数据驱动的提分方案，支持学习效果追踪</div>
        <div class="ai-card-desc">高粘性学习闭环设计，数据驱动优化续费潜力</div>
      </div>
    </div>
    <div class="pain-section">
      <div class="section-title-small" style="margin-top:0">
        解决痛点
      </div>
      <div class="section-title" style="margin-bottom:0">
        专注解决小初高学生英语学习核心痛点
      </div>
      <div class="section-title-l">
        用AI技术带来全新学习体验
      </div>
      <div class="pain-cards">
        <div class="pain-card">
          <div class="pain-card-title">
            <span class="icon icon5"></span>
            <span class="txt">学习压力大，效率低？</span>
          </div>
          <ul>
            <li>智能拆解知识点，精准匹配课标要求</li>
            <li>个性化学习方案，告别无效刷题</li>
            <li>闭环训练系统，让每一分钟都高效</li>
          </ul>
        </div>
        <div class="pain-card">
          <div class="pain-card-title">
            <span class="icon icon6"></span>
            <span class="txt">只会死记硬背，不会用？</span>
          </div>
          <ul>
            <li>AI虚拟教师实时指导，培养英语思维</li>
            <li>情景化互动练习，告别哑巴英语</li>
            <li>多维学习报告，清晰掌握进步轨迹</li>
          </ul>
        </div>
        <div class="pain-card">
          <div class="pain-card-title">
            <span class="icon icon7"></span>
            <span class="txt">反复刷题，学习缺乏规划？</span>
          </div>
          <ul>
            <li>智能诊断当前水平，定制专属路径</li>
            <li>动态调整难度，循序渐进提升</li>
            <li>重点难点针对性突破，不浪费时间</li>
          </ul>
        </div>
        <div class="pain-card">
          <div class="pain-card-title">
            <span class="icon icon8"></span>
            <span class="txt">效果难以持续？</span>
          </div>
          <ul>
            <li>"测→练→学→测→评"科学闭环，巩固学习成果</li>
            <li>趣味化设计，保持学习动力</li>
            <li>家长随时查看进度，见证真实进步</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="service-section">
      <div class="section-title-small" style="margin-top:0">
        全程护航
      </div>
      <div class="section-title" style="margin-bottom:0">
        一站式运营服务，助您轻松创业
      </div>
      <div class="section-title-l">
        总部为您提供"从选址、培训、招生到运营"强大支持成为坚实后盾
      </div>
      <div class="service-cards">
        <div class="service-card">
          <div class="icon icon9"></div>
          <div class="service-card-title">选址评估系统</div>
          <div class="service-card-desc">科学规划开店布局，降低选址风险</div>
        </div>
        <div class="service-card">
          <div class="icon icon10"></div>
          <div class="service-card-title">总部培训体系</div>
          <div class="service-card-desc">快速培养运营团队，7天掌握核心技能</div>
        </div>
        <div class="service-card">
          <div class="icon icon11"></div>
          <div class="service-card-title">季度经营分析</div>
          <div class="service-card-desc">持续优化盈利模式，确保稳定增长</div>
        </div>
      </div>
    </div>
    <div class="cooperation-section">
      <div class="cooperation-content">
        <div class="cooperation-content-left">
          <div class="title">立即获取合作方案</div>
          <div class="txt">
            填写您的信息，我们的合作顾问将在24小时内与您联系，为您提供详细的合作方案和投资回报分析。
          </div>
          <div class="cooperation-img"><!-- 图片站位 --></div>
        </div>

        <form class="cooperation-form">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="姓名" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="ruleForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="意向合作城市" prop="cityArr">
              <el-cascader
                v-model="ruleForm.cityArr"
                :options="adressInfo"
                :props="{
                  expandTrigger: 'hover',
                  label: 'regionName',
                  value: 'regionCode',
                }"
                @change="handleChange"
              ></el-cascader>
            </el-form-item>
            <!-- <el-form-item label="意向合作类型" prop="type"> -->
            <el-form-item label="快捷需求类型" prop="type">
              <el-select
                v-model="ruleForm.type"
                placeholder="请选择快捷需求类型"
              >
                <el-option
                  label="请问我所在的地区有晓A精灵的加盟校了吗？"
                  value="1"
                ></el-option>
                <el-option
                  label="对项目很感兴趣，请将晓A精灵项目资料发邮件给我！"
                  value="2"
                ></el-option>
                <el-option
                  label="做为晓A精灵的加盟校能得到哪些支持？"
                  value="3"
                ></el-option>
                <el-option
                  label="请问，现在加盟晓A精灵所需要的费用有哪些？"
                  value="4"
                ></el-option>
                <el-option
                  label="想了解晓A精灵的加盟流程，请与我联系！"
                  value="5"
                ></el-option>
                <el-option
                  label="我想加盟晓A精灵，请电话联系我！"
                  value="6"
                ></el-option>
                <el-option
                  label="现在加盟晓A精灵，有什么优惠政策吗？"
                  value="7"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="详细需求" prop="desc">
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 4 }"
                v-model="ruleForm.remark"
              ></el-input>
            </el-form-item>
            <el-form-item class="button">
              <el-button type="primary" @click="submitForm('ruleForm')"
                >提交申请</el-button
              >
            </el-form-item>
          </el-form>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import adressInfo from "../js/adressInfo";
import { opportunityAdd } from "@/server/api.js";
export default {
  data() {
    var checkArr = (rule, value, callback) => {
      console.log(value, "value");

      if (!value || !value.length) {
        return callback(new Error("请选择"));
      } else {
        callback();
      }
    };
    const checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      adressInfo: Object.freeze(adressInfo),
      ruleForm: {
        name: "",
        phone: "",
        cityArr: [],
        province: "",
        city: "",
        area: "",
        type: "",
        remark: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, validator: checkPhone, trigger: "blur" }],
        cityArr: [{ required: true, validator: checkArr, trigger: "blur" }],
        type: [{ required: true, validator: checkArr, trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let data = { ...this.ruleForm };
          delete data.cityArr;
          const res = await opportunityAdd(data);
          if (res.code == 200) {
            this.ruleForm = {
              name: "",
              phone: "",
              cityArr: [],
              province: "",
              city: "",
              area: "",
              type: "",
              remark: "",
            };
            this.$message.success("提交成功");
          } else {
            this.$message.error(data.message);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleChange(e) {
      this.ruleForm.province = e[0];
      this.ruleForm.city = e[1];
      this.ruleForm.area = e[2];
    },
  },
  mounted() {
    console.log(adressInfo, "adressInfo");
  },
};
</script>

<style lang="scss" scoped>
.ai-card,
.pain-card,
.service-card {
  cursor: pointer;
  &:hover {
    transform: scale(1.02);
  }
}
#join {
  color: #9a212a;
  padding-top: 60px;
  background: #ffffff;
  .hero-bg {
    background: #F4D9D7;
    .hero {
      width: 1200px;
      margin: 0 auto;
      padding: 60px 0 60px 0;
      text-align: center;
      .hero-title {
        font-size: 38px;
        font-weight: bold;
        line-height: 1;
        margin-bottom: 12px;
      }
      .blue {
        color: #9a212a;
      }
      .hero-desc {
        color: #9a212a;
        font-size: 16px;
        margin-bottom: 8px;
      }
    }
  }
  .section-title-small {
    margin-top: 40px;
    color: #9a212a;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .section-title {
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 40px;
  }
  .section-title-l {
    color: #9a212a;
    text-align: center;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 40px;
  }
  .ai-advantage {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    gap: 24px;
    margin-bottom: 40px;
    .ai-card {
      flex: 1;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 2px 8px #dcdedf;
      padding: 32px 18px;
      .icon {
        width: 50px;
        height: 50px;
        margin: 0 auto 16px auto;
      }
      .icon1 {
        background-image: url(../assets/new-page/join/icon1.png);
        background-size: 100% 100%;
      }
      .icon2 {
        background-image: url(../assets/new-page/join/icon2.png);
        background-size: 100% 100%;
      }
      .icon3 {
        background-image: url(../assets/new-page/join/icon3.png);
        background-size: 100% 100%;
      }
      .icon4 {
        background-image: url(../assets/new-page/join/icon4.png);
        background-size: 100% 100%;
      }
      .ai-card-title {
        text-align: center;
        font-size: 18px;
        margin-bottom: 10px;
      }
      .ai-card-desc {
        position: relative;
        margin-bottom: 10px;
        padding: 0 8px 0 30px;
        font-size: 15px;
        color: #9a212a;
        &::before {
          color: #22c55e;
          content: "✔";
          position: absolute;
          left: 10px;
          font-weight: 600;
        }
      }
    }
  }
  .pain-section {
    background: #F4D9D7;
    padding: 48px 0;
    .pain-cards {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .pain-card {
        margin-bottom: 30px;
        width: 550px;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px #e5eaf3;
        padding: 32px 18px;
        .pain-card-title {
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          .icon {
            margin-right: 10px;
            border-radius: 4px;
            width: 40px;
            height: 40px;
          }
          .icon5 {
            background-image: url(../assets/new-page/join/icon5.png);
            background-size: 100% 100%;
          }
          .icon6 {
            background-image: url(../assets/new-page/join/icon6.png);
            background-size: 100% 100%;
          }
          .icon7 {
            background-image: url(../assets/new-page/join/icon7.png);
            background-size: 100% 100%;
          }
          .icon8 {
            background-image: url(../assets/new-page/join/icon8.png);
            background-size: 100% 100%;
          }
          .txt {
            font-size: 17px;
          }
        }
        ul {
          padding-left: 28px;
          margin: 0;
          li {
            display: flex;
            align-items: center;
            position: relative;
            list-style-type: none;
            font-size: 15px;
            color: #9a212a;
            margin-bottom: 8px;
            &::before {
              line-height: 16px;
              font-size: 8px;
              text-align: center;
              border-radius: 50%;
              background: #22c55e;
              width: 16px;
              height: 16px;
              color: #ffffff;
              content: "✔";
              position: absolute;
              left: -26px;
              font-weight: 600;
            }
          }
        }
      }
    }
  }

  .service-section {
    width: 1200px;
    margin: 0 auto;
    padding: 48px 0 80px 0;
    .service-cards {
      display: flex;
      gap: 24px;
      .service-card {
        flex: 1;
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 8px #e5eaf3;
        padding: 32px 18px;
        text-align: center;
        .icon {
          width: 48px;
          height: 48px;
          margin: 0 auto 16px auto;
        }
        .icon9 {
          background-image: url(../assets/new-page/join/icon9.png);
          background-size: 100% 100%;
        }
        .icon10 {
          background-image: url(../assets/new-page/join/icon10.png);
          background-size: 100% 100%;
        }
        .icon11 {
          background-image: url(../assets/new-page/join/icon11.png);
          background-size: 100% 100%;
        }
        .service-card-title {
          font-size: 18px;
          margin-bottom: 10px;
        }
        .service-card-desc {
          font-size: 15px;
          color: #9a212a;
        }
      }
    }
  }

  .cooperation-section {
    background: #F4D9D7;
    padding: 48px 0;
    .cooperation-content {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      gap: 40px;
      align-items: flex-start;
      .cooperation-content-left {
        flex: 1;
        .title {
          font-size: 30px;
          font-weight: bold;
        }
        .txt {
          margin: 20px 0 40px;
          color: #9a212a;
          font-size: 16px;
        }
        .cooperation-img {
          width: 100%;
          height: 440px;
          border-radius: 8px;
          box-shadow: 0 4px 24px #e5eaf3;
          background-image: url(../assets/new-page/hone/img2.jpg);
          background-size: 100% 100%;
        }
      }
      .cooperation-form {
        height: 600px;
        background: #fff;
        padding: 32px 24px;
        border-radius: 8px;
        flex: 1;
        box-shadow: 0 2px 8px #e5eaf3;
      }
    }
  }
}
</style>

<style lang="scss">
.cooperation-form {
  .el-form {
    .el-form-item {
      padding-top: 10px;
      margin-bottom: 0;
      display: flex;
      flex-direction: column;
      .el-form-item__content {
        margin-left: 0 !important;
        .el-cascader,
        .el-select {
          width: 100%;
        }
      }
      &::before {
        display: none;
      }
      .el-form-item__label {
        width: fit-content !important;
        text-align: left;
      }
    }
    button {
      margin-top: 20px;
      width: 100%;
      background: #9a212a;
      color: #fff;
      border: none;
      padding: 14px;
      border-radius: 5px;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
</style>
